import { render, staticRenderFns } from "./IconAttachment.vue?vue&type=template&id=03429c0c&scoped=true&"
import script from "./IconAttachment.vue?vue&type=script&lang=js&"
export * from "./IconAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03429c0c",
  null
  
)

export default component.exports